export const supplierPortalTheme = {
  colors: {
    bg: '#f7fafc',
    surface: '#ffffff',
    text: '#0f172a',
    muted: '#64748b',
    primary: '#0ea5e9',
    success: '#16a34a',
    warning: '#f59e0b',
    danger: '#dc2626',
    border: '#e2e8f0',
    header: '#0b1120',
    nav: '#ffffff',
  },
  spacing: {
    xxs: '4px',
    xs: '8px',
    sm: '12px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
  },
  radii: {
    card: '12px',
    control: '8px',
  },
  shadows: {
    card: '0 8px 24px rgba(0, 0, 0, 0.06)',
    modal: '0 12px 32px rgba(15, 23, 42, 0.15)',
  },
  typography: {
    fontFamily:
      "'Inter', 'Inter var', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'SF Pro Display', 'Roboto', sans-serif",
    baseSize: '15px',
    heading: {
      md: '24px',
      sm: '18px',
    },
  },
}
